
import React from 'react';
import Heading from '@/components/ui/heading';
import PricingBackground from './pricing/PricingBackground';
import PricingToggle from './pricing/PricingToggle';
import PricingCard from './pricing/PricingCard';
import { usePricingPlans } from './pricing/usePricingPlans';

/**
 * Pricing component displays the pricing plans with a 3D background effect
 * and allows toggling between monthly and annual billing cycles
 */
const Pricing: React.FC = () => {
  const { plans, isAnnual, setIsAnnual } = usePricingPlans();

  return (
    <section id="pricing" className="py-20 relative overflow-hidden">
      <PricingBackground />
      
      <div className="bg-gradient-to-b from-gray-800/70 to-gray-900/70 backdrop-blur-sm py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="inline-block py-1 px-3 text-sm font-medium bg-blue-900/40 text-blue-300 rounded-full backdrop-blur-sm border border-blue-800/50 mb-3">Simple Pricing</span>
            <Heading level={2} className="mb-4">
              Pricing Plans
            </Heading>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Choose the plan that fits your research needs. All plans include our AI-powered analysis engine.
            </p>
          </div>

          <div className="text-center mb-6">
            <span className="inline-block py-1 px-4 text-sm font-medium bg-green-900/40 text-green-400 rounded-full border border-green-800/50">
              Save 15% with Annual billing
            </span>
          </div>

          <PricingToggle isAnnual={isAnnual} setIsAnnual={setIsAnnual} />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {plans.map((plan, index) => (
              <PricingCard key={index} plan={plan} isAnnual={isAnnual} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
